import { Component } from '@angular/core';

@Component({
    selector: 'app-freeway-layout-footer-social-instagram',
    templateUrl: './freeway-layout-footer-social-instagram.component.html',
    standalone: false
})
export class FreewayLayoutFooterSocialInstagramComponent {}
